import { serializeData } from "../../../Utils/utils"

// The filter bar and the table speak the UI's names; the Lookup activity API speaks its own.
// One translation for both the list and the export, so the file and the screen can never
// disagree about what was asked for.

// `serializeData` encodes a number filter as the string the older tables read
// ("1000,2000" for a range, "> 1000" otherwise). The API takes an explicit pair instead, so the
// range is read off the raw filter rather than parsed back out of that string.
//
// The API's bounds are inclusive, so "greater than" and "less than" arrive as >= and <=. A row
// sitting exactly on the boundary is therefore kept where the control implies it would be
// dropped. Expressing it exactly would need the API to grow strict bounds; until it does, this
// is the closest it can answer.
const NUMBER_FILTER_BOUNDS = {
  is_between: ({ min, max }) => [min, max],
  is_equal_to: ({ min }) => [min, min],
  is_greater_than: ({ min }) => [min, null],
  is_less_than: ({ min }) => [null, min]
}

const rangeParams = (prefix, filter) => {
  const bounds = NUMBER_FILTER_BOUNDS[filter?.type]
  if (!bounds) return {}

  const [min, max] = bounds(filter)

  return {
    ...(min != null ? { [`${prefix}_min`]: min } : {}),
    ...(max != null ? { [`${prefix}_max`]: max } : {})
  }
}

// The table's columns are named for what they display; the API sorts by the stored fields.
const ORDERING_FIELDS = {
  date: "lookup_date",
  card: "card_last4",
  amount: "transaction_amount"
}

export const toLookupFilterParams = (filters) => {
  // `card`, `amount` and `fee_charged` are re-derived below; the rest of the serialized
  // output (date range, program, channel) already matches the API.
  const { card, amount: _amount, fee_charged: _fee, ...serialized } = serializeData(filters) ?? {}

  return {
    ...serialized,
    ...(card ? { card_last4: card } : {}),
    ...rangeParams("amount", filters?.amount),
    ...rangeParams("fee", filters?.fee_charged)
  }
}

export const toApiOrdering = (ordering) => {
  if (!ordering) return ordering

  const descending = ordering.startsWith("-")
  const field = descending ? ordering.slice(1) : ordering
  const mapped = ORDERING_FIELDS[field] ?? field

  return descending ? `-${mapped}` : mapped
}
